module.exports = __webpack_public_path__ + "img/age-quiz.d5b59113.png";